import { render } from "./ButtonView.vue?vue&type=template&id=c0668cb2&scoped=true"
import script from "./ButtonView.vue?vue&type=script&lang=js"
export * from "./ButtonView.vue?vue&type=script&lang=js"

import "./ButtonView.vue?vue&type=style&index=0&id=c0668cb2&lang=scss&scoped=true"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c0668cb2"]])

export default __exports__